import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChessBoard, faChessKnight, faCircleUser, faLayerGroup, faRankingStar, faUsers } from '@fortawesome/free-solid-svg-icons';
import { playPath } from 'utils/play/inviteUrl';
import type { PlayTab } from './PlayLayout';

export type PlayerTabKey = 'match' | 'standings' | 'deck' | 'profile';
export type HostTabKey = 'round' | 'players' | 'standings';

/** Decision 22: Match, Standings, Deck, Profile. Deck is omitted when decklists are off. */
export const playerTabs = (code: string, active: PlayerTabKey, decklists: boolean): PlayTab[] => {
  const tabs: PlayTab[] = [
    { key: 'match', label: 'Match', icon: <FontAwesomeIcon icon={faChessKnight} />, to: playPath(code), active: active === 'match' },
    { key: 'standings', label: 'Standings', icon: <FontAwesomeIcon icon={faRankingStar} />, to: playPath(code, 'standings'), active: active === 'standings' },
  ];
  if (decklists) tabs.push({ key: 'deck', label: 'Deck', icon: <FontAwesomeIcon icon={faLayerGroup} />, to: playPath(code, 'deck'), active: active === 'deck' });
  tabs.push({ key: 'profile', label: 'Profile', icon: <FontAwesomeIcon icon={faCircleUser} />, to: `/play/me?from=${code}`, active: active === 'profile' });
  return tabs;
};

/** Decision 21: Round, Players, Standings, with the red badge on Round. */
export const hostTabs = (code: string, active: HostTabKey, roundBadge: number): PlayTab[] => [
  { key: 'round', label: 'Round', icon: <FontAwesomeIcon icon={faChessBoard} />, to: `${playPath(code, 'host')}?tab=round`, active: active === 'round', badge: roundBadge },
  { key: 'players', label: 'Players', icon: <FontAwesomeIcon icon={faUsers} />, to: `${playPath(code, 'host')}?tab=players`, active: active === 'players' },
  { key: 'standings', label: 'Standings', icon: <FontAwesomeIcon icon={faRankingStar} />, to: `${playPath(code, 'host')}?tab=standings`, active: active === 'standings' },
];
